var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _ellipse, _circle2, _circle3, _circle4, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrokenFlower(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 325,
    height: 137,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E8EEF4",
    d: "M186.298 80.496c8.863 2.318 14.056 8.19 0 11.89-11.128 2.93-21.084.173-31.041 2.758-9.956 2.585-10.757 14.991-25.757 14.331s-13.483-10.712-24.025-12.435-22.255-.173-29.869-4.653c-7.613-4.48 14.056-8.445 18.742-11.891 4.685-3.447 3.514-8.1 22.255-9.65s31.04 2.412 38.654 6.031 20.499.862 31.041 3.619"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#183C67",
    fillRule: "evenodd",
    d: "M139.342 58.343a2.99 2.99 0 0 0-2.874-3.822l-17.344.01c-3.423-11.314-14.89-21.782-30.396-26.272-13.805-3.998-27.437-2.28-36.569 3.603-1.617 1.042-2.685 2.716-3.22 4.564L44.902 50.36l-1.663 5.743c-.535 1.848-.527 3.834.284 5.58 4.575 9.851 15.18 18.588 28.984 22.585a55 55 0 0 0 9.303 1.855c11.791 1.3 22.703-1.49 29.856-7.338l15.021 9.508a2.99 2.99 0 0 0 4.471-1.695l3.009-10.388z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#91BDED",
    d: "M193.419 60.29c-6.553-.093-11.79-5.484-11.698-12.042.092-6.559 5.478-11.801 12.03-11.71 6.553.093 11.79 5.484 11.698 12.042-.092 6.559-5.478 11.801-12.03 11.71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#91BDED",
    d: "M175.869 83.415c19.111-8.928 28.174-25.531 29.16-32.159l-23.303-3.391c.09 10.314-3.681 26.63-8.591 31.69-.02 1.424 2.734 3.86 2.734 3.86"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#91BDED",
    d: "M175.869 83.415c19.111-8.928 28.174-25.531 29.16-32.159l-23.303-3.391c.09 10.314-3.681 26.63-8.591 31.69-.02 1.424 2.734 3.86 2.734 3.86"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#91BDED",
    strokeLinecap: "round",
    strokeWidth: 6.365,
    d: "M228.161 72.196S204.33 83.89 166.975 81.7 81.95 63.516 81.95 63.516"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 154,
    height: 26,
    x: 78,
    y: 60,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#91BDED",
    strokeLinecap: "round",
    strokeWidth: 6.365,
    d: "M228.161 72.196S204.33 83.89 166.975 81.7 81.95 63.516 81.95 63.516"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4585D3",
    fillOpacity: 0.27,
    d: "M76.455 65.376 62.281 50.499l25.801 10.034zM106.776 71.146 96.632 60.499l18.465 7.18zM135.776 77.146l-10.144-10.647 12.868 3.5z",
    style: {
      mixBlendMode: "multiply"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.26,
    cy: 14.26,
    r: 14.26,
    fill: "#EA580C",
    transform: "scale(-1 1)rotate(-77.414 -86.587 203.87)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA580C",
    d: "M261.225 82.126a2.907 2.907 0 0 0-2.467 3.93c2.255 6.185 7.679 18.919 15.616 23.903 6.872 4.315 15.837 2.407 20.026-4.262 4.188-6.67 2.013-15.574-4.858-19.89-7.937-4.984-21.765-4.338-28.317-3.681"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.26,
    cy: 14.692,
    fill: "#EA580C",
    rx: 14.26,
    ry: 14.692,
    transform: "scale(-1 1)rotate(-77.414 -86.492 189.627)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.828,
    cy: 13.828,
    r: 13.828,
    fill: "#EA580C",
    transform: "scale(-1 1)rotate(-77.414 -62.742 197.16)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.26,
    cy: 14.26,
    r: 14.26,
    fill: "#EA580C",
    transform: "scale(-1 1)rotate(-77.414 -72.683 184.758)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.05,
    cy: 6.05,
    r: 6.05,
    fill: "#FDE047",
    transform: "scale(-1 1)rotate(-77.414 -75.054 188.43)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#4585D3",
    d: "M139.367 58.396a2.99 2.99 0 0 0-2.873-3.822l-17.344.009c-3.423-11.313-14.89-21.781-30.396-26.271-13.806-3.998-27.437-2.28-36.569 3.602-1.617 1.042-2.686 2.717-3.22 4.565l-4.036 13.934 17.498-3.923L74.09 60.543l8.424-2.898 8.424-2.898 13.218 14.503 19.959-4.896 10.079 11.909zM33.601 94.382c.474 1.864 1.487 3.573 3.069 4.667 8.934 6.18 22.501 8.346 36.43 4.804a55 55 0 0 0 8.962-3.11l-8.475-3.764 6.784-11.647-12.17-9.536-5.797 6.764-17.172-6.214-13.104 12.241z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#4585D3",
    d: "m134.087 92.253 16.319 7.05a2.99 2.99 0 0 0 4.153-2.371l1.352-10.73-11.812-10.192-18.952 7.946-15.316-12.265-7.87 4.175 7.84 13.326-10.573 8.36 6.511 6.602c11.85-.554 22.193-5.01 28.348-11.901"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenFlower);
export default __webpack_public_path__ + "static/media/broken-flower.8425fb28a44dda2e847325dcfd950553.svg";
export { ForwardRef as ReactComponent };